import React, { useEffect, useState } from 'react';
import './CookieConsentSettings.scss';
import {setCookie, getCookie} from '../../../../utils/cookiesUtil';
import {Button} from '../../../UI';

const COOKIE_CATEGORIES = {
  necessary: {
    label: 'Необходимые',
    description: 'Эти файлы cookie необходимы для функционирования веб-сайта и не могут быть отключены в наших системах. Обычно они устанавливаются только в ответ на действия посетителей, которые представляют собой запрос на услуги, такие как настройка параметров конфиденциальности, вход в систему или заполнение форм. Вы можете настроить свой браузер таким образом, чтобы он блокировал или предупреждал вас об этих файлах cookie, но это может привести к неправильной работе некоторых частей веб-сайта.',
    required: true,
  },
  functional: {
    label: 'Функциональные',
    description: 'Эти cookie помогают улучшить взаимодействие с сайтом. Они собирают данные о вашей системе и настройках, например информацию об устройстве и браузере, но только после того, как вы войдете в систему. Отключение этих cookie затрудняет выявление и устранение ошибок на сайте.',
  },
  analytical: {
    label: 'Аналитические',
    description: 'Эти файлы cookie позволяют нам подсчитывать посещения и источники трафика, чтобы мы могли измерять и улучшать производительность нашего веб-сайта. Они помогают нам знать, какие страницы наиболее и наименее популярны, и видеть, как посетители перемещаются по сайту. Если эти файлы cookie отключены, мы не будем знать, когда пользователь посещал наш веб-сайт, и не сможем отслеживать работу веб-сайта.',
  },
  marketing: {
    label: 'Рекламные',
    description: 'Рекламные файлы cookie необходимы для отслеживания посетителей на веб-сайте и показа релевантной рекламы.',
  },
};

const CookieConsentSettings = ({setIsModalVisible}) => {
  const [consent, setConsent] = useState({});
  const [expanded, setExpanded] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // setVisible(true);
    setConsent(COOKIE_CATEGORIES);
    const saved = getCookie('cookieConsent');
    if (!saved) {
      const initial = {};
      Object.keys(COOKIE_CATEGORIES).forEach((key) => {
        initial[key] = COOKIE_CATEGORIES[key].required || false;
      });
      setConsent(initial);
      setVisible(true);
    }
  }, []);

  const toggleCategory = (key) => {
    if (COOKIE_CATEGORIES[key].required) return;
    setConsent((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const handleAccept = () => {
    setCookie('cookieConsent', JSON.stringify(consent), 365);
    setVisible(false);
    window.location.reload();
  };

  const handleExpand = (key) => {
    setExpanded((prev) => (prev === key ? null : key));
  };

  const handleClose = () => {
    setVisible(false);
    setIsModalVisible(true);
  };

  if (!visible) return null;

  return (
    <div className="cookie-fullscreen">
      <div className="cookie-container">
        <h1>Настройки файлов cookie</h1>
        <p>
          Нажмите на заголовки различных категорий, чтобы узнать больше и изменить наши настройки по умолчанию.
          Вы можете отозвать свое согласие или изменить настройки вашего согласия в любое время,
          перейдя по ссылке &quot;Управление файлами cookie&quot; в нижней части нашего веб-сайта,
          или вы можете отключить файлы cookie в настройках вашего веб-браузера или мобильного устройства.
          Для получения дополнительной информации, пожалуйста, ознакомьтесь с нашей Политикой конфиденциальности.
        </p>
        <div className="accordion">
          {Object.entries(COOKIE_CATEGORIES).map(([key, { label, description, required }]) => (
            <div key={key} className="accordion-item">
              <div className="accordion-header">
                <input
                  type="checkbox"
                  checked={consent[key]}
                  disabled={required}
                  onChange={() => toggleCategory(key)}
                />
                <div className="accordion-title" onClick={() => handleExpand(key)}>
                  <span>{label}</span>
                  <div className={`arrow ${expanded === key ? 'expanded' : ''}`} />
                </div>
              </div>
              {expanded === key && (
                <div className="accordion-body">
                  <p>{description}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        <div className="cookie-actions">
          <Button className="close-btn" onClick={handleClose} text='Назад'/>
          <Button className="accept-btn" onClick={handleAccept} text='Сохранить настройки'/>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentSettings;
